import React, { FC, useState } from 'react';
import { Videos } from 'src/graphql/schema.graphql';
import { NeauviaPlayerLayer, NeauviaPlayerProps } from 'src/components/player';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { makeTransition } from 'src/utils/motion/transitions';
import { media } from 'src/styles/designs';
import { ar } from 'src/styles/common';
import {
  MaterialPageLoader,
  MaterialPageTemplate,
} from 'src/modules/materials/components/MaterialPage';
import { ConstraintContainer } from 'src/components/common/ConstraintContainer';
import { NeauviaItem } from 'src/models/directus';
import { MaterialPageTab } from 'src/modules/materials/components/MaterialPage/MaterialPageTabs/types';

export interface VideoPageTemplateProps {
  tabs: MaterialPageTab<NeauviaItem>[];
  video: Videos;
  playerProps?: Partial<NeauviaPlayerProps>;
}

const VideoPlayerArea = motion(styled.div`
  margin: 0px calc(-1 * var(--constraint-container-right-inner-margin)) 0px
    calc(-1 * var(--constraint-container-left-inner-margin));

  margin-bottom: 10px;
  ${media.w.greaterThanOrEqual.desktop} {
    margin-bottom: 0;
  }
`);

const VideoPlayerAreaInner = styled.div`
  position: relative;
  ${ar(16 / 9, 'max(20vw, calc(100vh - var(--header-static-height) - 130px))')};
  & > * {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`;

const wistiaOptions = {
  playSuspendedOffScreen: false,
};

export const VideoPageTemplate: FC<VideoPageTemplateProps> = ({
  tabs,
  video,
  playerProps,
  children,
}) => {
  const [sourceRef, setSourceRef] = useState<HTMLDivElement | null>(null);

  return (
    <MaterialPageTemplate sourceElement={sourceRef} tabs={tabs} item={video}>
      {children}
      <ConstraintContainer>
        <VideoPlayerArea
          key={video.id}
          ref={setSourceRef}
          {...makeTransition({
            fade: true,
            from: 'rightMore',
            to: 'leftMore',
          })}
        >
          <VideoPlayerAreaInner>
            <NeauviaPlayerLayer
              autoPlay={true}
              video={video}
              wistiaOptions={wistiaOptions}
              {...playerProps}
            />
          </VideoPlayerAreaInner>
        </VideoPlayerArea>
      </ConstraintContainer>
    </MaterialPageTemplate>
  );
};

export const VideoPageLoader = styled(MaterialPageLoader)`
  header {
    width: auto;
    height: auto;
    margin: 0px calc(-1 * var(--constraint-container-right-inner-margin)) 0px
      calc(-1 * var(--constraint-container-left-inner-margin));

    ${ar(
      16 / 9,
      'max(20vw, calc(100vh - var(--header-static-height) - 130px))',
    )};
  }
`;
